// 定义一些公共的属性和方法

//加密有关
const algorithm = "aes-192-cbc";
const keyArray = [220, 193, 77, 43, 54, 31, 93, 241, 11, 168, 19, 233, 209, 21, 30, 9, 135, 110, 0, 46, 250, 51, 79, 27];
const ivArray = [180, 162, 211, 45, 30, 50, 224, 21, 21, 214, 87, 61, 122, 169, 90, 154];

// 暴露出这些属性
export default {
  algorithm,
  keyArray,
  ivArray
};